// Magyarország
export default {
	status: {
		400: "A kérés sikertelen! Kérjük, próbálja újra később",
		401: "A bejelentkezési munkamenet lejárt! Kérjük, jelentkezzen be újra",
		403: "A jelenlegi fióknak nincs hozzáférési engedélye",
		404: "Az általad megpróbált erőforrás nem létezik",
		405: "Helytelen kérési módszer! Kérjük, próbálja újra később",
		408: "A kérés időtúllépés! Kérjük, próbálja újra később",
		500: "Szolgáltatás hiba történt",
		990: "Fiókja hosszú ideje be van fagyasztva a nem teljesített feladatok miatt",
		10030008: "Kérjük, a készpénzfelvétel igénylése előtt adja vissza a támogatási alapot",
		10030010: "A meghívókód nem létezik",
		10030011: "Túllépte a maximális bejelentkezési időt",
		10030012: "Nem felel meg a bejelentkezési feltételeknek, kérjük, először végezze el a feladatot",
		10030013: "Bejelentkezési konfigurációs hiba, kérjük, lépjen kapcsolatba az ügyfélszolgálattal",
		10030014: "Nem a megengedett időszakban van",
		10030015: "A tag nem létezik",
		10030016:
			"Kedves felhasználó: Gratulálunk! Sikeresen befejezte a termékpromóció 100%-át. Kérjük, vegye fel a kapcsolatot a platform támogatásával a visszaállítás kéréséhez.",
		10030017: "Nem sikerült megtalálni a terméket, kérjük, lépjen kapcsolatba az ügyfélszolgálattal",
		10030018: "Nincs elegendő számlaegyenleg",
		10030019: "A fiók letiltásra került",
		10030020: "A kereskedelemre korlátozott fiók",
		10030021: "A fiók visszavonását tilos",
		10030022: "Tranzakciós jelszó hiba",
		10030023: "A visszavonási számla nincs összekapcsolva, kérjük, először kösse össze a visszavonási számlát",
		10030024: "Régi jelszó hiba",
		10030027: "A kivonás korlátozva van. Kérjük, lépjen kapcsolatba az ügyfélszolgálattal további részletekért",
		10030028: "Az alacsony hitelpontok megakadályozzák a pénzfelvételt",
		10030030: "Nem a megengedett időszakban van",
		10030031: "Kérjük, lépjen kapcsolatba az ügyfélszolgálattal a mai feladat visszaállításához",
		10030050: "A rendelés lejárt. Kérjük, lépjen kapcsolatba az ügyfélszolgálattal a segítségért."
	},
	errorHandler: {
		InternalError: "Belső hiba a JavaScript motorban",
		ReferenceError: "Az objektum nem található",
		TypeError: "Helytelen típus vagy objektum használat",
		RangeError: "Paraméter túllépte a tartományt a beépített objektumok használatakor",
		SyntaxError: "Szintaktikai hiba",
		EvalError: "Az Eval helytelen használata",
		URIError: "URI hiba",
		UnknownError: "Ismeretlen"
	},
	Network: {
		timedout: "A kérés időtúllépése! Kérjük, próbálja újra később",
		error: "Hálózati hiba! Kérjük, próbálja újra később"
	},
	request: {
		NoMoreData: "Nincs több adat",
		OnlyImage: "Kérjük, csak képfájlokat töltsön fel.",
		FileMaxSize: "A fájl mérete meghaladja a maximális értéket, amely {0}M"
	},
	response: {
		loading: "Betöltés",
		success: "Siker",
		fail: "Sikertelen",
		complete: "Teljes"
	},
	page: {
		noVerify: "A pénztárca nincs ellenőrizve, kérjük először ellenőrizze a pénztárcáját",
		notexist: "Elnézést, a megpróbált oldal nem létezik~"
	}
};
